import React from 'react';

export const StickyContext = React.createContext({ isVisible: false });
